import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsCriticality, PmsCriticality } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsCriticality>
    useData={usePmsCriticality}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
